export default __webpack_public_path__ + "static/media/learnmore-candle.870c981d.svg";